import React, {Component} from 'react';

import {BrowserRouter, Route, Switch, Redirect} from 'react-router-dom';
import loadable from '@loadable/component';

import {withCopies} from 'src/services/TranslationService';

// Components
import {GeneralLoading} from 'src/components/common/general-loading/GeneralLoading';

import { PublicRoute } from 'src/public-route';
import {PrivateRoute} from 'src/private-route';

// Pages
const SegmentFormLoaded = loadable(() => import(/* webpackChunkName: "SegmentForm" */ 'src/pages/segment-form/SegmentForm'));
const SegmentForm = (props) => <SegmentFormLoaded {...props} />;

const LogoutLoaded = loadable(() => import(/* webpackChunkName: "Logout" */ 'src/pages/Logout'));
const Logout = (props) => <LogoutLoaded {...props} />;

const ErrorLoaded = loadable(() => import(/* webpackChunkName: "Error" */ 'src/pages/Error'));
const Error = (props) => <ErrorLoaded {...props} />;

const LoginLoaded = loadable(() => import(/* webpackChunkName: "Login" */ 'src/pages/Login'));
const Login = (props) => <LoginLoaded {...props} />;

const RegisterLoaded = loadable(() => import(/* webpackChunkName: "Register" */ 'src/pages/Register'));
const Register = (props) => <RegisterLoaded {...props} />;

const ForgotPasswordLoaded = loadable(() => import(/* webpackChunkName: "ForgotPassword" */ 'src/pages/ForgotPassword'));
const ForgotPassword = (props) => <ForgotPasswordLoaded {...props} />;

const ResetPasswordLoaded = loadable(() => import(/* webpackChunkName: "ResetPassword" */ 'src/pages/ResetPassword'));
const ResetPassword = (props) => <ResetPasswordLoaded {...props} />;

const AccessDarwinexLoaded = loadable(() => import(/* webpackChunkName: "AccessDarwinex" */ 'src/pages/AccessDarwinex'));
const AccessDarwinex = (props) => <AccessDarwinexLoaded {...props} />;

const CoownerEmailValidationLoaded = loadable(() => import(/* webpackChunkName: "CoownerEmailValidation" */ 'src/pages/CoownerEmailValidation'));
const CoownerEmailValidation = (props) => <CoownerEmailValidationLoaded {...props} />;

class Routes extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {currentLanguage, loadingLanguage} = this.props;
        let langBaseName = '/';
        if (currentLanguage !== 'en') {
            langBaseName += currentLanguage;
        }

        const routerBasename = langBaseName;// + process.env.PUBLIC_URL;

        return <BrowserRouter
                basename={routerBasename}
            >
                <Switch>
                    <Route exact path="/">
                        <Redirect to="/welcome"/>
                    </Route>

                    <PrivateRoute
                        exact path="/welcome"
                        component={SegmentForm}
                    />

                    <PrivateRoute
                        exact path="/access-darwinex"
                        component={AccessDarwinex}
                    />

                    <PublicRoute
                        exact
                        path="/login"
                        component={Login}
                    />

                    <PublicRoute
                        exact
                        path="/register"
                        component={Register}
                    />

                    <PublicRoute
                        exact
                        path="/password/recovery"
                        component={ForgotPassword}
                    />

                    <PublicRoute
                        exact
                        path="/password/reset/confirm"
                        component={ResetPassword}
                    />

                    {/*

                    <PrivateRoute
                        exact path="/logout"
                        component={Logout}
                    />
                    */}

                    <PublicRoute
                        exact
                        path="/regulatory-profile/coowner/email-validation/success"
                        component={CoownerEmailValidation}
                    />

                    <Route path="*">
                        { !loadingLanguage ? <Error/> : <GeneralLoading /> }
                    </Route>
                </Switch>
            </BrowserRouter>;
    }
}

export default withCopies(Routes);
